import { useTranslation } from "gatsby-plugin-react-i18next";

type GiftCardErrorMessages = {
	default: string;
	no_value: string;
	cart_paid: string;
	invalid_method: string;
	remove_error: string;
	already_applied: string;
};
export const useGiftCardErrorMessages = (): GiftCardErrorMessages => {
	const { t } = useTranslation();

	const defaultMessage = t(
		"Please make sure that the gift card code is correct and try again.",
	);
	const stripeErrorMessages: GiftCardErrorMessages = {
		default: defaultMessage,
		remove_error: t("Something went wrong, please try again."),
		no_value: t("The gift card has no remaining value."),
		cart_paid: t(
			"The cart is already fully paid, can't add any more gift cards.",
		),
		invalid_method: t(
			"You can not use a gift card as payment method when buying another gift card.",
		),
		already_applied: t("You can't use the same gift card multiple times."),
	};
	return stripeErrorMessages;
};
